import React, { createContext, useState } from "react";

import { ColumnsValues } from "../components/OnBoarding/UploadCenter/UploadFile/UploadFileValue/InputUpload/getInputColumns";
import { Company } from "../models/company";
import { User } from "../models/user";

export type CSVValueProps = {
  [x: string]: string | number | boolean | undefined;
};

export interface BillingContact {
  name: string;
  email: string;
  phone: string;
  address: string;
}

interface OnBoardingContextProps {
  users: User[];
  company?: Company;
  uploadedDataCSV: CSVValueProps[];
  setUploadedDataCSV: React.Dispatch<React.SetStateAction<CSVValueProps[]>>;
  isOpenUploadModal: boolean;
  setIsOpenUploadModal: React.Dispatch<React.SetStateAction<boolean>>;
  currentColumnType: ColumnsValues | undefined;
  setCurrentColumnType: React.Dispatch<React.SetStateAction<ColumnsValues | undefined>>;
  handleSetUser: (users: User) => void;
  handleSetCompany: (company: Company) => void;
  cleanUser: () => void;
  totalBranches: number;
  setTotalBranches: React.Dispatch<React.SetStateAction<number>>;
  billingContact: BillingContact;
  setBillingContact: React.Dispatch<React.SetStateAction<BillingContact>>;
  useAdminDetails: boolean;
  setUseAdminDetails: React.Dispatch<React.SetStateAction<boolean>>;
}

const onBoardingContext = createContext<OnBoardingContextProps>({} as OnBoardingContextProps);

interface OnBoardingProviderProps {
  children: React.ReactChild;
}

const OnBoardingProvider = ({ children }: OnBoardingProviderProps) => {
  const [company, setCompany] = useState<Company>();
  const [users, setUsers] = useState<User[]>([]);
  const [uploadedDataCSV, setUploadedDataCSV] = useState<CSVValueProps[]>([]);
  const [isOpenUploadModal, setIsOpenUploadModal] = useState<boolean>(false);
  const [currentColumnType, setCurrentColumnType] = useState<ColumnsValues>();
  const [totalBranches, setTotalBranches] = useState<number>(0);
  const [billingContact, setBillingContact] = useState<BillingContact>({
    name: "",
    email: "",
    phone: "",
    address: "",
  });
  const [useAdminDetails, setUseAdminDetails] = useState<boolean>(false);

  const handleSetUser = (user: User) => {
    setUsers((state) => (state ? [...state, user] : [user]));
  };

  const cleanUser = () => {
    setUsers([]);
  };

  const handleSetCompany = (company: Company) => {
    setCompany(company);
  };

  return (
    <onBoardingContext.Provider
      value={{
        company,
        users,
        handleSetCompany,
        handleSetUser,
        uploadedDataCSV,
        setUploadedDataCSV,
        isOpenUploadModal,
        setIsOpenUploadModal,
        currentColumnType,
        setCurrentColumnType,
        cleanUser,
        totalBranches,
        setTotalBranches,
        billingContact,
        setBillingContact,
        useAdminDetails,
        setUseAdminDetails,
      }}
    >
      {children}
    </onBoardingContext.Provider>
  );
};

export { onBoardingContext, OnBoardingProvider };
